/* eslint-disable jsx-a11y/click-events-have-key-events */
import React from 'react';
import PropTypes from 'prop-types';
import { Checkbox } from 'web-ui-components/lib/atoms/forms';
import classNames from 'classnames';
import { formatSortCode } from '../../utils/accountUtils';
import styles from './AccountCard.styles';

export const AccountCard = ({
	id,
	name,
	accountHolder,
	sortCode,
	accountNumber,
	number,
	type,
	currentBalance,
	availableBalance,
	isSelected,
	hasCheckbox,
	onClick,
}) => {
	const accountCardClassName = classNames(
		'c-m-payee-card',
		{
			'c-m-payee-card--selected': isSelected,
			[styles.selectedCardVM]: isSelected,
		},
		[styles.cardVM]
	);
	return (
		<div
			className={accountCardClassName}
			role="button"
			tabIndex={0}
			onClick={() => {
				onClick(id);
			}}
			data-cy="account-payee-card"
		>
			<div className="c-m-payee-card__sector">
				{accountHolder && (
					<div className="c-m-payee-card__body">
						<span className="c-m-payee-card__segment-gamma">{accountHolder}</span>
					</div>
				)}
				<div className="c-m-payee-card__header">
					<span className="c-m-payee-card__segment-alpha">{name}</span>
				</div>
				<div className="c-m-payee-card__body">
					<span className="c-m-payee-card__segment-gamma">
						{type === 'credit_card' ? number : `${formatSortCode(sortCode)} | ${accountNumber}`}
					</span>
					{hasCheckbox && (
						<div className="c-m-payee-card__segment-delta">
							<Checkbox
								id={id}
								onChange={(event) => {
									onClick(id);
									event.stopPropagation();
								}}
								checked={isSelected}
								label=""
							/>
						</div>
					)}
				</div>
				<div className="c-m-payee-card__footer">
					{currentBalance !== '' ? <span className="c-m-payee-card__segment-epsilon">{currentBalance}</span> : null}
					{availableBalance !== '' ? (
						<span className="c-m-payee-card__segment-zeta">{availableBalance} available</span>
					) : null}
				</div>
			</div>
		</div>
	);
};

AccountCard.defaultProps = {
	hasCheckbox: false,
};

AccountCard.propTypes = {
	id: PropTypes.string.isRequired,
	number: PropTypes.string,
	accountHolder: PropTypes.string,
	type: PropTypes.string.isRequired,
	sortCode: PropTypes.string,
	accountNumber: PropTypes.string,
	name: PropTypes.string.isRequired,
	currentBalance: PropTypes.string,
	availableBalance: PropTypes.string,
	onClick: PropTypes.func.isRequired,
	hasCheckbox: PropTypes.bool,
	isSelected: PropTypes.bool.isRequired,
};
export default AccountCard;
